import React from "react";
import "./Header.css";
import logo from "../../Images/bbLogo_dark.png";

const Header = ({ handlePopup }) => {
  return (
    <div className="header-container">
      <div className="logo">
        <img src={logo} alt="logo" className="logoimg" width="200px" />
      </div>
      <button className="premier-cta-button" onClick={handlePopup}>
        Let's Dive In
        <span className="arrow">→</span>
      </button>
    </div>
  );
};

export default Header;
